module.exports = __webpack_public_path__ + "b082cf5ba8835d153381d3373bc6ba4c.jpg";